<template>
    <a :href="url" v-if="name_converted" target="_blank" rel="noopener noreferrer" class="social-link">
        <Icon :name="name_converted" />
    </a>
</template>

<script src="./socialLink.js" />
<style src="./socialLink.scss" lang="scss" scoped />
